const statusRegion = document.getElementById('pura-accessibility-status');
const alertRegion = document.getElementById('pura-accessibility-alert');
let lastStatus = '';
let statusSequence = 0;

function placeLiveRegionInActiveContext(region) {
  const activeDialog = document.querySelector('cart-drawer[open], x-modal[open], x-drawer[open]');
  const target = activeDialog || document.body;
  if (region.parentElement !== target) target.append(region);
}

function announce(message, { assertive = false } = {}) {
  const region = assertive ? alertRegion : statusRegion;
  if (!region || !message) return;

  const normalizedMessage = String(message).trim();
  if (!normalizedMessage) return;

  statusSequence += 1;
  const sequence = statusSequence;
  placeLiveRegionInActiveContext(region);
  region.textContent = '';

  window.setTimeout(() => {
    if (sequence !== statusSequence) return;
    region.textContent = normalizedMessage;
    lastStatus = normalizedMessage;
  }, 50);
}

document.addEventListener('variant:add', (event) => {
  const item = event.detail?.items?.[0];
  const productTitle = item?.product_title || item?.title || 'Product';
  announce(`${productTitle} added to cart.`);
});

document.addEventListener('cart:error', (event) => {
  announce(event.detail?.error || 'The cart could not be updated.', { assertive: true });
});

document.addEventListener('variant:change', (event) => {
  if (!event.detail?.variant || event.detail.variant.available === false) {
    announce('This product option is unavailable.', { assertive: true });
  }
});

document.addEventListener('line-item:change', (event) => {
  const productTitle = event.target.closest('line-item')?.dataset.productTitle || 'Product';
  const quantity = Number(event.detail?.quantity ?? 0);
  const message = quantity === 0 ? `${productTitle} removed from cart.` : `${productTitle} quantity updated to ${quantity}.`;
  const drawer = event.target.closest('cart-drawer[open]');
  if (drawer && pendingCartFocus) {
    pendingCartFocus.message = message;
  } else {
    announce(message);
  }
});

document.addEventListener('pura:status', (event) => {
  announce(event.detail?.message, { assertive: event.detail?.type === 'error' });
});

let inertedElements = [];
let pendingCartFocus = null;
let cartOpener = null;
let cancelPendingCartFocusRestore = null;

document.addEventListener('line-item:will-change', (event) => {
  pendingCartFocus = {
    productTitle: event.target.closest('line-item')?.dataset.productTitle || '',
    lineKey: event.detail?.lineKey || event.target.closest('line-item')?.dataset.lineKey || '',
    targetQuantity: Number(event.detail?.targetQuantity ?? 0),
  };
});

document.addEventListener('cart-drawer:refreshed', (event) => {
  const drawer = event.target.closest?.('cart-drawer') || event.target;
  if (!drawer?.matches?.('cart-drawer') || !drawer.hasAttribute('open') || !pendingCartFocus) return;

  requestAnimationFrame(() => {
    const message = pendingCartFocus?.message;
    const matchingItem = pendingCartFocus?.targetQuantity > 0
      ? Array.from(drawer.querySelectorAll('line-item')).find((item) => item.dataset.lineKey === pendingCartFocus.lineKey)
      : null;
    const focusTarget = matchingItem?.querySelector('[data-line-key], input, button, a')
      || drawer.querySelector('.cart-drawer__close-button');
    focusTarget?.focus({ preventScroll: true });
    pendingCartFocus = null;
    if (message) {
      window.setTimeout(() => announce(message), 200);
    }
  });
});

function makeCartBackgroundInert(cartDrawer) {
  cartOpener = document.activeElement instanceof HTMLElement ? document.activeElement : null;
  queueMicrotask(() => {
    if (!cartDrawer.hasAttribute('open')) return;
    inertedElements = Array.from(document.body.children)
      .filter((element) => element !== cartDrawer
        && !['pura-accessibility-status', 'pura-accessibility-alert'].includes(element.id)
        && !element.hasAttribute('inert'))
      .map((element) => {
        element.setAttribute('inert', '');
        return element;
      });
  });
}

function restoreCartBackground() {
  inertedElements.forEach((element) => element.removeAttribute('inert'));
  inertedElements = [];
  const opener = cartOpener;
  cartOpener = null;
  [statusRegion, alertRegion].forEach((region) => {
    if (region && region.parentElement !== document.body) document.body.prepend(region);
  });
  if (!opener?.isConnected) return;
  // Safari and late third-party widgets can override the shared trap's return
  // focus after the leave transition. Restore once after that window, but
  // cancel immediately if the shopper starts a new keyboard/pointer action.
  cancelPendingCartFocusRestore?.();
  let cancelledByUser = false;
  const cancelForUserAction = () => { cancelledByUser = true; };
  const userEvents = ['keydown', 'pointerdown', 'touchstart'];
  userEvents.forEach((type) => document.addEventListener(type, cancelForUserAction, { capture: true, once: true }));
  const cleanup = () => {
    userEvents.forEach((type) => document.removeEventListener(type, cancelForUserAction, { capture: true }));
    cancelPendingCartFocusRestore = null;
  };
  const timer = window.setTimeout(() => {
    cleanup();
    if (!cancelledByUser && opener.isConnected && !document.querySelector('cart-drawer[open]')) {
      opener.focus({ preventScroll: true });
    }
  }, 350);
  cancelPendingCartFocusRestore = () => {
    window.clearTimeout(timer);
    cleanup();
  };
}

const initializedCartDrawers = new WeakSet();

function initializeCartDrawerAccessibility(root = document) {
  const drawers = root.matches?.('cart-drawer') ? [root] : root.querySelectorAll?.('cart-drawer') || [];
  drawers.forEach((drawer) => {
    if (initializedCartDrawers.has(drawer)) return;
    initializedCartDrawers.add(drawer);
    drawer.addEventListener('dialog:before-show', () => makeCartBackgroundInert(drawer));
    drawer.addEventListener('dialog:after-show', () => {
      const activeElement = document.activeElement;
      if (activeElement !== drawer && !drawer.contains(activeElement)) {
        drawer.querySelector('.cart-drawer__close-button')?.focus({ preventScroll: true });
      }
    });
    drawer.addEventListener('dialog:after-hide', restoreCartBackground);
  });
}

initializeCartDrawerAccessibility();
document.addEventListener('shopify:section:load', (event) => initializeCartDrawerAccessibility(event.target));

window.addEventListener('pageshow', restoreCartBackground);
